import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "reactstrap";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { useWizard } from "components/wizard/WizardContext";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { getCourseIds } from "./utilsFunctions";
import { inputHeight } from "./helper";

const SelectCourseIdStep = () => {
  const { id } = useParams();
  const isFirstRender = useRef(true);

  const { updateValues, values, next } = useWizard();
  const masterDropdowns = useSelector(
    (state) => state.globalData.masterDropdowns
  );

  const [courseIdDropdown, setCourseIdDropdown] = useState([]);

  const {
    language,
    academicCareer,
    attribute,
    classes,
    board,
    stream,
    courses,
  } = values;

  useEffect(() => {
    if (language && academicCareer && attribute && classes && board && stream) {
      fetchCourseIdsDropdownOptions();
    }
  }, [language, academicCareer, attribute, classes, board, stream]);

  const fetchCourseIdsDropdownOptions = async () => {
    const apiResponse = await getCourseIds({
      languageId: [language.value],
      academicCareerId: [academicCareer.value],
      attribute: [attribute.label],
      classId: [classes.value],
      boardId: board.value,
      academicGroupId: stream.value,
    });

    setCourseIdDropdown(apiResponse);

    if (isFirstRender.current && id) {
      isFirstRender.current = false;
      return; // Skip first updating value on `edit`
    }
    updateValues("courses", []);
  };

  const isNextDisabled =
    !language ||
    !academicCareer ||
    !attribute ||
    !classes ||
    !board ||
    !stream ||
    !courses?.length;

  return (
    <>
      <h2 className="text-bold">Select Course ID</h2>
      <Row>
        <Col>
          <AAutoComplete
            label="Career*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.academicCareer}
            currentValue={academicCareer}
            isShowCount={false}
            isMulti={false}
            handleChange={(value) => {
              updateValues("academicCareer", value);
            }}
            inputKey="academicCareer"
          />
        </Col>
        <Col>
          <AAutoComplete
            label="Class*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.classes}
            isShowCount={false}
            isMulti={false}
            currentValue={classes}
            handleChange={(value) => {
              updateValues("classes", value);
            }}
            inputKey="classes"
          />
        </Col>
      </Row>

      <Row className="my-2">
        <Col>
          <AAutoComplete
            label="Attribute*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.attribute}
            isShowCount={false}
            isMulti={false}
            currentValue={attribute}
            handleChange={(value) => {
              updateValues("attribute", value);
            }}
            inputKey="attribute"
          />
        </Col>
        <Col>
          <AAutoComplete
            label="Language*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.languages}
            isShowCount={false}
            isMulti={false}
            currentValue={language}
            handleChange={(value) => {
              updateValues("language", value);
            }}
            inputKey="language"
          />
        </Col>
      </Row>

      <Row className="my-2">
        <Col>
          <AAutoComplete
            label="Board*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.board}
            isShowCount={false}
            isMulti={false}
            currentValue={board}
            handleChange={(value) => {
              updateValues("board", value);
            }}
            inputKey="board"
          />
        </Col>
        <Col>
          <AAutoComplete
            label="Stream*"
            placeholder="Select"
            height={inputHeight}
            items={masterDropdowns.stream}
            isShowCount={false}
            isMulti={false}
            currentValue={stream}
            handleChange={(value) => {
              updateValues("stream", value);
            }}
            inputKey="stream"
          />
        </Col>
      </Row>

      <AAutoComplete
        label="Course ID*"
        placeholder="Select"
        height={inputHeight}
        items={courseIdDropdown}
        isShowCount={true}
        isMulti={true}
        currentValue={courses}
        handleChange={(value) => {
          updateValues("courses", value);
        }}
        inputKey="courses"
      />

      <footer className="mt-4 float-right">
        <AButton
          disabled={isNextDisabled}
          onClick={() => {
            next();
          }}
          className="ml-auto"
          variant="primary_filled"
        >
          Next
        </AButton>
      </footer>
    </>
  );
};

export default SelectCourseIdStep;
